import React from 'react';
import { Box, Typography, IconButton, Card, Link } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import OlcButton from '~/components/General/OlcButton';

import './style.scss';

const NoRecords = ({
  icon,
  title,
  message,
  messageWidth = 'min(100%, 580px)',
  buttonIcon,
  buttonText,
  onClickButton,
  onCloseHandler,
  linkText = '',
  linkUrl = '',
  buttonStyle = {},
  minBoxHeight = '274px',
  boxRadius = '7.967px',
  boxPadding = '40px 40px',
}) => {
  return (
    <Card
      className="olcNoRecordsCard"
      sx={{
        background: '#fff',
        boxShadow: 'none',
        padding: boxPadding,
        borderRadius: boxRadius,
        minHeight: minBoxHeight,
        '@media (max-width: 575px)': {
          padding: '32px 16px',
        },
      }}
    >
      <Box className="noRecordsContent">
        {onCloseHandler && (
          <IconButton onClick={onCloseHandler} sx={{ position: 'absolute', right: 12, top: 12 }}>
            <CloseIcon />
          </IconButton>
        )}

        {/* Main icon */}
        {icon}

        {/* Title */}
        <Typography className="noRecordsTitle" sx={{ margin: '0' }} gutterBottom>
          {title}
        </Typography>

        {/* Message */}
        <Typography
          className="noRecordsMessage"
          sx={{
            width: messageWidth,
          }}
          m={0}
        >
          {message}
        </Typography>

        {linkText && linkUrl && (
          <>
            <Link
              href={linkUrl}
              target="_blank"
              sx={{ color: '#ed5c2f', textDecoration: 'underline' }}
              className="linkText"
            >
              {linkText}
            </Link>
          </>
        )}

        {/* Button (optional) */}

        {buttonText && (
          <Box className="primaryButton">
            <OlcButton
              variant="primary"
              style={buttonStyle}
              startIcon={buttonIcon}
              onClick={onClickButton}
            >
              {buttonText}
            </OlcButton>
          </Box>
        )}
      </Box>
    </Card>
  );
};

export default NoRecords;
